// src/pages/permissions/CompanyForm.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  TextField,
  Button,
  Box,
  Grid,
  Typography,
  FormHelperText,
  Card,
  CardContent,
} from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import companyService from '../../services/companyService';
import { toUpper } from 'lodash';

const CompanyForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({ name: '' });

  useEffect(() => {
    const fetchCompany = async () => {
      if (id) {
        const response = await companyService.getCompanyById(id);
        setInitialValues(response.data);
      }
    };
    fetchCompany();
  }, [id]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Vendor name is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (id) {
        await companyService.updateCompany(id, values);
      } else {
        await companyService.createCompany(values);
      }
      navigate('/vendor');
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <LayoutContainer>
      <AdminHeader title={id ? 'Edit Vendor' : 'Add Vendor'} backTo='/vendor' />
      <Box
        className='page-content-wrapper scrollable'
        p={3}
        sx={{ display: 'flex', backgroundColor: '#efefef' }}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <form onSubmit={handleSubmit} style={{ width: '50%' }}>
              <Card>
                <CardContent>
                  <Grid container spacing={3} sx={{ p: 1 }}>
                    <Grid item xs={12}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Vendor Name <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        placeholder='Vendor name'
                        name='name'
                        fullWidth
                        value={values.name}
                        onChange={(e) => {
                          const capitalizedValue = toUpper(e.target.value); // Capitalize first letter
                          handleChange({
                            target: { name: 'name', value: capitalizedValue },
                          });
                        }}
                        onBlur={handleBlur}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.name && errors.name
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                      />
                      {touched.name && errors.name && (
                        <FormHelperText error>{errors.name}</FormHelperText>
                      )}
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      type='submit'
                      variant='contained'
                      sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                    >
                      {id ? 'Update' : 'Create'}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </LayoutContainer>
  );
};

export default CompanyForm;
